package com.appsyde.shared.modules.team.domain.usecase

import com.appsyde.shared.modules.team.domain.model.TeamUser
import com.appsyde.shared.modules.team.domain.repository.TeamRepository

class GetTeamUsersUseCase(
    private val repository: TeamRepository
) {
    suspend operator fun invoke(): List<TeamUser> = repository.getUsers()
}
